import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Conversation from '../../components/shared/Conversation';
import { watchConversation, sendMessage, markAllReadByClient } from '../../utils/messages';
import * as ds from '../../constants/dashboardStyles';

const styles = {
  card: ds.card,
  title: ds.cardTitle,
  description: ds.cardDescription,
  error: ds.error,
};

export default function MessagesCard() {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user?.email) return undefined;
    return watchConversation(
      user.email,
      setMessages,
      (err) => setError(err.message.replace('Firebase: ', '')),
    );
  }, [user?.email]);

  // Anything from us is marked read as soon as the client has it on screen.
  // Failures are ignored deliberately: a read receipt is not worth showing an
  // error over, and the next render will try again.
  useEffect(() => {
    const ids = messages
      .filter((message) => message.from === 'admin' && !message.readByClient)
      .map((message) => message.id);
    markAllReadByClient(ids).catch(() => {});
  }, [messages]);

  const handleSend = (body) => sendMessage({
    clientEmail: user.email,
    from: 'client',
    body,
    authorEmail: user.email,
  });

  return (
    <div style={styles.card}>
      <div style={styles.title}>Ask a question</div>
      <p style={styles.description}>
        Anything you need — about a quote, your project, or timings. We'll reply here.
      </p>

      {error && <div style={styles.error}>{error}</div>}

      <Conversation
        messages={messages}
        side="client"
        onSend={handleSend}
        placeholder="Type your question…"
        emptyText="No messages yet — ask us anything."
      />
    </div>
  );
}
